import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from '../Sidebar/Sidebar';
import Header from '../Header';
import '../../styles/styles.css';
import rateLimitService from '../../services/rateLimitService';

const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleDrawer = () => {
    setSidebarOpen(!sidebarOpen);
  };

  useEffect(() => {
    // Iniciar el polling de rate limits
    rateLimitService.startPolling();

    // Limpiar el polling cuando el componente se desmonte
    return () => {
      rateLimitService.stopPolling();
    };
  }, []);

  return (
    <div className="App">
      <Header toggleDrawer={toggleDrawer} />
      <Sidebar open={sidebarOpen} toggleDrawer={toggleDrawer} />
      <main className={sidebarOpen ? 'content shift-right' : 'content'}>
        <Outlet />
      </main>
    </div>
  );
};

export default MainLayout;